import * as React from "react";

import {  IMPDTreeProps, MPDTree } from "src/mpd-library";

// export interface IListTreeProps {
//   listItemType: React.ComponentClass<any> | React.StatelessComponent<any>;
//   nodes?: Array<IMPDTreeNode>;
//   loading?: boolean;
//   onGetNode?: MPDTreeEventHandler;
//   onRowClicked?: MPDTreeEventHandler;
//   getNodeId?: string;
//   handleNodeCollapse?(nodeData?: IMPDTreeNode): void;
//   handleNodeExpand?(nodeData?: IMPDTreeNode): void;
// }

import "./styles.css";

export class ListTree extends React.Component<
  IMPDTreeProps
> {
  public constructor(props: any) {
    super(props);
  }

  public render() {
    const { loading, NodeItem, contents, getNodeId, onGetNode, onNodeClick, onNodeCollapse, onNodeExpand } = this.props;

    return (
      <MPDTree
        NodeItem={NodeItem}
        loading={loading}
        contents={contents}
        onNodeClick={onNodeClick}
        onNodeCollapse={onNodeCollapse}
        onNodeExpand={onNodeExpand}
        getNodeId={getNodeId}
        onGetNode={onGetNode}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/list-tree/list-tree.tsx